import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Badge, Button, Collapse, Icon, ListItem, Typography, Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';

const NavButtonStyle = styled(Button)(({ theme, isexact }) => ({
  color: theme.palette.text.secondary,
  justifyContent: 'flex-start',
  width: '100%',
  '&.active': {
    color: theme.palette.primary.main,
    backgroundColor: isexact === 'true' ? theme.palette.action.selected : 'transparent',
  },
}));

const TitleStyle = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: theme.typography.pxToRem(14),
  textTransform: 'capitalize',
  marginLeft: theme.spacing(2),
}));

const IconStyle = styled(Icon)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
}));

const NavItem = ({
  children,
  className,
  depth,
  href,
  icon: Icon,
  info: Info,
  open: openProp,
  title,
  badge,
  ...rest
}) => {
  const [open, setOpen] = useState(openProp);
  const location = useLocation();

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen);
  };

  let paddingLeft = 8;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  const style = { paddingLeft };
  const isExact = location.pathname === href;

  if (children) {
    return (
      <ListItem disableGutters key={title} {...rest}>
        <NavButtonStyle onClick={handleToggle} style={style}>
          <IconStyle>{Icon && <Icon size="20" />}</IconStyle>
          <TitleStyle>{title}</TitleStyle>
          {badge && (
            <Chip
              label={badge}
              color="warning"
              variant="outlined"
              size="small"
              sx={{ ml: 1, height: 20, fontSize: 10 }}
            />
          )}
          {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </NavButtonStyle>
        <Collapse in={open}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem disableGutters key={title} {...rest}>
      <NavButtonStyle component={RouterLink} style={style} to={href} isexact={isExact.toString()} end>
        <IconStyle>{Icon && <Icon size="20" />}</IconStyle>
        <TitleStyle>{title}</TitleStyle>
        {badge && (
          <Chip
            label={badge}
            variant="outlined"
            size="small"
            color="warning"
            sx={{ ml: 1, height: 20, fontSize: 10 }}
          />
        )}
        {Info && <Info />}
      </NavButtonStyle>
    </ListItem>
  );
};

NavItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  depth: PropTypes.number.isRequired,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  info: PropTypes.elementType,
  open: PropTypes.bool,
  title: PropTypes.string.isRequired,
  badge: PropTypes.string,
};

export default NavItem;
